import React, { useEffect, useState } from 'react'
import GD from '../GD'
import { Dialog } from '../components/Dialog'
import { Button } from '../components/Button'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

// header height — keeps the header (and its close button) usable while the notice is shown
const HEADER_HEIGHT = 78

const Wrapper = styled.pre`
  margin: 0 auto;
  font: inherit;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`

const GuestNotice = () => {
  const { t } = useTranslation()

  const [isGuest, setIsGuest] = useState(false)
  const [hidden, setHidden] = useState(false)

  useEffect(() => {
    GD.AUTH_COMPLETE.subscribe(({ profile }) => {
      setIsGuest(profile.type === 'guest')
    }, 'GuestNotice')

    return () => {
      GD.AUTH_COMPLETE.unsubscribe('GuestNotice')
    }
  }, [])

  if (!isGuest || hidden) return null

  const onAccept = () => setHidden(true)

  return (
    <Dialog
      title=""
      id="modal-portal"
      topOffset={HEADER_HEIGHT}
      clickOutside={false}
      onClose={onAccept}
      style={{ minWidth: 0, width: '85%' }}
    >
      <Dialog.Content>
        <Wrapper>{t('main.security_banner')}</Wrapper>
      </Dialog.Content>
      <Dialog.Footer style={{ justifyContent: 'center' }}>
        <Button color="swiss" onClick={onAccept}>{t('main.accept')}</Button>
      </Dialog.Footer>
    </Dialog>
  )
}

export default GuestNotice
